// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"d7d5683e","431":"013d58c4","657":"59049ecc","726":"d762836c"}[chunkId] + ".chunk.js";
};